import React, { useState } from 'react';

import { FormControl, Input, Container, FormLabel, Button, HStack, Text } from '@chakra-ui/react';

import { login } from '../api';

import { Link } from 'react-router-dom';

// onSuccess opzionale
const Login = ({ onSuccess }) => {
  const initFormData = {
    email: '',
    password: '',
  };
  const [formData, setFormData] = useState(initFormData);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const isDisabled = formData.email === '' || formData.password === '';

  const onChange = (event) => {
    setError('');
    const keyValue = {};
    keyValue[event.target.name] = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      ...keyValue,
    }));
  };

  const onSubmit = async () => {
    setError('');
    setIsLoading(true);
    const result = await login(formData.email, formData.password);
    setIsLoading(false);
    if (result.success) {
      onSuccess && onSuccess(result.user);
      return;
    }
    setError(result.message);
  };

  return (
    <Container my={50} bg='#3c4d5f' centerContent>
      <FormControl>
        <FormLabel htmlFor='email'>Email address</FormLabel>
        <Input
          id='email'
          type='email'
          name='email'
          value={formData.email}
          onChange={onChange}
          placeholder='Email'
        />
        <FormLabel htmlFor='password'>Password</FormLabel>
        <Input
          id='password'
          type='password'
          name='password'
          value={formData.password}
          onChange={onChange}
          placeholder='Password'
        />
        <FormLabel color='tomato' mt={5}>
          {error}
        </FormLabel>
        <HStack mt={4} justifyContent='space-between'>
          <Button
            size={'lg'}
            // mt={4}
            onClick={onSubmit}
            isLoading={isLoading}
            isDisabled={isDisabled}
          >
            Login
          </Button>
          <Text as={Link} to='/' color='gold' fontWeight={600} size={'lg'} >
            Torna alla Home
          </Text>
        </HStack>
      </FormControl>
    </Container>
  );
};

export default Login;
